export function getStoredUser() {
  try {
    const raw = localStorage.getItem('user')
    return raw ? JSON.parse(raw) : {}
  } catch (e) {
    return {}
  }
}

export function isUserLoggedIn(user) {
  const u = user || getStoredUser()
  return !!(u && u.id && u.token)
}

export function clearStoredUser() {
  localStorage.removeItem('user')
  try {
    localStorage.removeItem(AUTH_BACKUP_LS)
    sessionStorage.removeItem('user_backup')
  } catch (e) { /* ignore */ }
  clearAuthBackupCookie()
}

const AUTH_BACKUP_COOKIE = 'ct_user_backup'
const AUTH_BACKUP_LS = 'user_pay_backup'
export const FRONT_AUTH_RESTORED_EVENT = 'front-auth-restored'

function clearAuthBackupCookie() {
  document.cookie = `${AUTH_BACKUP_COOKIE}=; path=/; max-age=0; SameSite=Lax`
}

/** 仅备份登录必要字段，避免 cookie 超长被浏览器丢弃 */
function buildAuthBackupRaw(raw) {
  let user
  try {
    user = typeof raw === 'string' ? JSON.parse(raw) : raw
  } catch (e) {
    return null
  }
  if (!user || !user.id || !user.token) return null
  const compact = {
    id: user.id,
    token: user.token,
    role: user.role,
    username: user.username,
    name: user.name,
    email: user.email,
    avatar: user.avatar,
    phone: user.phone,
    onlineStatus: user.onlineStatus,
    createdAt: user.createdAt
  }
  return JSON.stringify(compact)
}

function readCookieBackup() {
  const match = document.cookie.match(new RegExp(`(?:^|; )${AUTH_BACKUP_COOKIE}=([^;]*)`))
  if (!match) return null
  try {
    return decodeURIComponent(match[1])
  } catch (e) {
    return null
  }
}

/**
 * 跳转支付宝前备份登录态（localStorage + sessionStorage + cookie）
 * 支付宝回跳/新标签页可能导致登录态丢失，回跳后用备份恢复
 */
export function persistAuthBeforePay() {
  const raw = localStorage.getItem('user')
  if (!raw) return
  const backup = buildAuthBackupRaw(raw)
  if (!backup) return
  try {
    localStorage.setItem(AUTH_BACKUP_LS, backup)
  } catch (e) { /* ignore */ }
  try {
    sessionStorage.setItem('user_backup', backup)
  } catch (e) { /* ignore */ }
  try {
    // 紧凑备份，降低 cookie 超长被丢弃的概率
    document.cookie = `${AUTH_BACKUP_COOKIE}=${encodeURIComponent(backup)}; path=/; max-age=7200; SameSite=Lax`
  } catch (e) { /* ignore */ }
}

function applyRestoredUser(raw) {
  try {
    const user = JSON.parse(raw)
    if (!user || !user.id || !user.token) return false
    const current = getStoredUser()
    const merged = Object.assign({}, current, user)
    localStorage.setItem('user', JSON.stringify(merged))
    try {
      localStorage.setItem(AUTH_BACKUP_LS, buildAuthBackupRaw(merged) || raw)
    } catch (e) { /* ignore */ }
    window.dispatchEvent(new CustomEvent(FRONT_AUTH_RESTORED_EVENT, { detail: merged }))
    return true
  } catch (e) {
    return false
  }
}

/**
 * 支付回跳后恢复登录态，成功返回 true
 */
export function restoreAuthAfterPay() {
  if (isUserLoggedIn()) {
    return true
  }
  let raw = null
  try {
    raw = localStorage.getItem(AUTH_BACKUP_LS)
  } catch (e) { /* ignore */ }
  if (!raw) {
    try {
      raw = sessionStorage.getItem('user_backup')
    } catch (e) { /* ignore */ }
  }
  if (!raw) {
    raw = readCookieBackup()
  }
  if (!raw) return false
  return applyRestoredUser(raw)
}

export function isFrontRoute(path) {
  if (!path) return false
  return !path.startsWith('/manager')
    && path !== '/login'
    && path !== '/register'
}

export function dispatchFrontAuthExpired() {
  window.dispatchEvent(new CustomEvent('front-auth-expired'))
}

export const EMAIL_LOGIN_EVENT = 'show-email-login'

/** 前台系统首页（生产环境对应 https://codebin.xin/） */
export const FRONT_HOME_PATH = '/'
export const FRONT_HOME_URL = process.env.VUE_APP_FRONT_HOME || 'https://codebin.xin/'

/** 打开前台邮箱登录弹框（需在 Front 布局内或配合 /?login=1 使用） */
export function openEmailLoginDialog(redirect = '') {
  window.dispatchEvent(new CustomEvent(EMAIL_LOGIN_EVENT, {
    detail: { redirect: redirect || '' }
  }))
}

/** 带登录弹框参数的首页路由（Register 等独立页使用） */
export function buildLoginHomeLocation(redirect = '') {
  const query = { login: '1' }
  if (redirect) {
    query.redirect = redirect
  }
  return { path: FRONT_HOME_PATH, query }
}

export function redirectToFrontHome(router) {
  if (router) {
    router.replace(FRONT_HOME_PATH)
    return
  }
  window.location.href = FRONT_HOME_URL
}

export function isUserRole(user) {
  const u = user || getStoredUser()
  return u && u.role === 'USER'
}
